import type { AmbleContent } from "..";
import * as exampleAmble from "./example-amble";

/**
 * UK-specific ambles for SimpleBusiness UK
 */
export const simplybusinessUkAmbles: Record<string, AmbleContent> = {
  "example-amble": exampleAmble.amble,
};
